export default __webpack_public_path__ + "static/media/img4.e9c1a79d.jpg";